import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import ZoomInIcon from 'material-ui-icons/ZoomIn';
import ZoomOutIcon from 'material-ui-icons/ZoomOut';
import PageNextIcon from 'material-ui-icons/KeyboardArrowDown';
import PagePrevIcon from 'material-ui-icons/KeyboardArrowUp';
import FullscreenIcon from 'material-ui-icons/Fullscreen';
import withStyles from 'material-ui/styles/withStyles';
import DashboardButton from './dashboard-button';
import DashboardInput from './dashboard-input';
import styles from './styles';

const Dashboard = ({
	classes,
	inputError,
	pageNumber, pageNumbers,
	zoomIn, zoomOut,
	handlePrevPage, handleNextPage,
	handlePNInputChange,
	handleFullscreen
}) => (
	<Paper className={classes.dashboard}>
		<DashboardButton desktopOnly handler={zoomOut}>
			<ZoomOutIcon/>
		</DashboardButton>
		<DashboardButton desktopOnly handler={zoomIn}>
			<ZoomInIcon/>
		</DashboardButton>
		<div className={classes.paging}>
			<DashboardButton
				handler={handlePrevPage}
				disabled={pageNumber === 1}
			>
				<PagePrevIcon/>
			</DashboardButton>
			<DashboardInput
				value={pageNumber}
				onChange={handlePNInputChange}
				error={inputError}
			/>
			<p className={classes.pageNumbers}>out of {pageNumbers}</p>
			<DashboardButton
				handler={handleNextPage}
				disabled={pageNumber === pageNumbers}
			>
				<PageNextIcon/>
			</DashboardButton>
		</div>
		<DashboardButton handler={handleFullscreen}>
			<FullscreenIcon/>
		</DashboardButton>
	</Paper>
);

Dashboard.propTypes = {
	pageNumber: PropTypes.number,
	pageNumbers: PropTypes.number,
	classes: PropTypes.object.isRequired,
	inputError: PropTypes.bool.isRequired,
	zoomIn: PropTypes.func.isRequired,
	zoomOut: PropTypes.func.isRequired,
	handlePrevPage: PropTypes.func.isRequired,
	handleNextPage: PropTypes.func.isRequired,
	handlePNInputChange: PropTypes.func.isRequired,
	handleFullscreen: PropTypes.func.isRequired
};

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/client/components/main/files/pdf-viewer-dashboard/dashboard.jsx